/**
 * Implementation of Login component
 *
 * @author - Harsh Tomar
 */

// dependencies
import { useMutation } from "react-query";
import { FormEvent, SyntheticEvent, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { RoutesProps, useLocation, useNavigate } from "react-router-dom";
import { emailLoginSignup } from "../../../api/reactQuery";
import { SERVER_URL } from '../../../managers/network'
import { When } from "react-if";

export default function Login(props: RoutesProps) {
  const [email, setEmail] = useState("");
  const { state } = useLocation() as { state: { url : string }};
  const url = state?.url;
  const navigate = useNavigate();
  const { mutate, isLoading, isError } = useMutation((variables: { email: string; url?: string })=>emailLoginSignup(variables),{
    onSuccess:()=>{
      navigate('/auth/email-sent', { state: { email }})
    }
  });

  function _handleLogin(e: FormEvent) {
    e.preventDefault();

    mutate({
      email,
      url
    });
  }

  const onClickGAUTHButton = (e: SyntheticEvent)=>{
    if(url){
      localStorage.setItem("_dmrs",url);
    }
    window.location.href = SERVER_URL + '/auth/login/google'
  }

  return (
    <>
      <h1 className="text-2xl mb-5 text-center">Login to Continue</h1>
      <When condition={url}>
        <h3 className="text-lg text-center">SSL tracking for <span className="font-bold">{url}</span></h3>
      </When>
      <div className="">
        <button className="btn-primary my-2 w-full flex items-center justify-center" onClick={onClickGAUTHButton}>
        <svg className="w-4 h-4 mr-2 -ml-1" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>
          Continue with Google
        </button>
        <p className="text-center">OR</p>
        <form onSubmit={_handleLogin}>
          <input
            className="input-field-primary w-full my-2"
            placeholder="Enter you email"
            required
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          {isLoading ? (
            <div className="flex justify-center items-center">
              <BiLoaderAlt className="animate-spin" size={28} />
            </div>
          ) : (
            <button className="btn-accent mt-1.5 w-full">
              Continue with E-mail
            </button>
          )}
          {isError && <p>{""}</p>}
        </form>
      </div>
    </>
  );
}
